import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IInputProps } from 'utils/types/common';
import { UseFormWatch, FieldValues } from 'react-hook-form';
import DisplayPassword from './DisplayPassword';

interface IProps extends IInputProps {
  watch: UseFormWatch<FieldValues>;
}

const ConfirmPasswordInput: React.FC<IProps> = ({
  register,
  watch,
  errors,
  title,
  placeHolder,
  name,
  disabled = false,
}) => {
  const err = Object.keys(errors)
    .filter((item) => item === name)
    .toString();

  const [showPass, setShowPass] = useState<boolean>(false);
  const [checkPass, setCheckPass] = useState<boolean>(false);

  return (
    <InputWrapper>
      <TextWrapper className={`${err || checkPass ? 'text-red' : ''}`}>
        {title}
      </TextWrapper>
      <PasswordWrapper>
        <Input
          disabled={disabled}
          type={showPass ? 'text' : 'password'}
          min='0'
          placeholder={placeHolder}
          className={`${err || checkPass ? 'border-red' : ''}`}
          {...register(name, {
            required: true,
            validate: (val) => {
              if (watch('password') !== val) {
                setCheckPass(true);
                return 'Passwords do not match';
              } else {
                setCheckPass(false);
                return true;
              }
            },
          })}
        />
        <DisplayPasswordWrapper>
          <DisplayPassword isShow={showPass} setShowPass={setShowPass} />
        </DisplayPasswordWrapper>
      </PasswordWrapper>
    </InputWrapper>
  );
};

export default ConfirmPasswordInput;

const InputWrapper = styled.div`
  position: relative;
  .border-red {
    border: 1px solid ${theme.colors.redText};
  }
  .border-red {
    border: 1px solid ${theme.colors.redText};
  }
  .text-red {
    color: ${theme.colors.redText};
  }
`;

const PasswordWrapper = styled.div`
  position: relative;
`;

const Input = styled.input`
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid ${theme.colors.gray_7};
  width: 100%;
  height: 40px;

  &:disabled {
    background-color: #e1e1e1;
    cursor: not-allowed;
  }
`;

const TextWrapper = styled.p`
  color: ${theme.colors.dark_500};
  font-size: ${theme.fontSizes.sm};
  margin-bottom: 8px;
`;

const DisplayPasswordWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
`;
